<div class="card mb-0 h-full flex flex-col">
  <div class="flex justify-between items-start mb-3">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Registered Agents</span>
      @if (loading()) {
        <p-skeleton height="2rem" width="3rem"></p-skeleton>
      } @else {
        <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ agents().length }}</div>
      }
    </div>
    <div class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-android text-green-500 text-lg"></i>
    </div>
  </div>
  <div class="space-y-2">
    @if (loading()) {
      <div class="space-y-2">
        <p-skeleton height="1rem" width="4rem"></p-skeleton>
        <p-skeleton height="2rem" width="100%"></p-skeleton>
      </div>
    } @else {
    <ng-template #agentList let-list="list">
      <div class="space-y-1">
        @for (agent of list; track agent.id) {
          <div class="px-2 py-1.5 bg-surface-50 dark:bg-surface-100 rounded">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-1.5">
                <div class="w-1 h-1 rounded-full" [class]="getStatusColor(agent.is_online)"></div>
                <div class="flex items-center gap-2">
                  <span class="text-surface-900 dark:text-surface-0 font-medium text-xs">{{ agent.name }}</span>
                  <span class="text-xs text-muted-color">v{{ agent.version || '1.0.0' }}</span>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <span class="text-xs text-muted-color">
                  @if (agent.is_online) { {{ agent.uptime_seconds | duration }} } @else { {{ agent.heartbeat_seconds | timeAgo }} }
                </span>
                <p-tag 
                  [value]="agent.type || 'unknown'" 
                  [severity]="agent.type === 'production' ? 'success' : 'info'"
                  class="text-xs scale-75">
                </p-tag>
              </div>
            </div>
          </div>
        }
      </div>
    </ng-template>

    @if (onlineAgents().length > 0) {
      <div class="mb-3">
        <div class="flex items-center gap-2 mb-1">
          <span class="text-xs font-medium text-green-600">Online ({{ onlineAgents().length }})</span>
        </div>
        <ng-container *ngTemplateOutlet="agentList; context: { list: onlineAgents() }"></ng-container>
      </div>
    }

    @if (offlineAgents().length > 0) {
      <div class="mt-2">
        <div 
          class="flex items-center gap-2 mb-1 cursor-pointer select-none group" 
          (click)="toggleOffline()">
          <span class="text-xs font-medium text-gray-600 group-hover:text-gray-800 transition-colors">
            Offline ({{ offlineAgents().length }})
          </span>
          <span class="text-[10px] text-blue-500 font-medium bg-blue-50 dark:bg-blue-900/20 px-1.5 py-0.5 rounded group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40 transition-colors">
            {{ showOffline() ? 'Hide' : 'Show' }}
          </span>
        </div>
        
        @if (showOffline()) {
          <ng-container *ngTemplateOutlet="agentList; context: { list: offlineAgents() }"></ng-container>
        }
      </div>
    }

    @if (agents().length === 0) {
      <div class="text-center py-1">
        <p class="text-muted-color text-xs">No agents connected</p>
      </div>
    }
    }
  </div>
</div>
